import React, { Suspense } from 'react'
import { Modal2 } from '@rst/ui-ts'
import { useStore } from 'effector-react'
import { $requestModal, closeRequestModal } from '../../model/request'
import { useMatchMedia, useModal } from '@rst/libs-ts'
import { lazyWithRetry } from '@rst/libs-ts'

const RequestForm = lazyWithRetry(() => import('./request-form'))

const ModalRequest = () => {
	const value = useStore($requestModal)
	const modal = useModal({ value })

	const md = useMatchMedia(screen => screen.greater.md)
	return (
		<Modal2
			{...modal}
			close={closeRequestModal}
			desktop={{ size: md ? 8 : 10 }}
		>
			{/* @ts-ignore */}
			{value ? (
				<Suspense fallback={() => null}>
					<RequestForm />
				</Suspense>
			) : null}
		</Modal2>
	)
}

export { ModalRequest }
